import { ProductName } from '../cover';
// TODO: should into the configuration. selectableUnits with options and a falsy value should the selected property also false. Here is the list of them
export const selectableFalsyValues = ['0', 'Nein'];
export const ngpProductConfiguration = {
    products: [
        {
            productName: ProductName.LEGALEXPENSES,
            productId: 'legalexpenses',
            vpmsProductIdentifier: 'Rechtsschutz',
            defaultLanguageId: 'de-at',
            policyAttributes: [
                {
                    name: 'AustrianLaw',
                    type: 'string',
                    defaultFunction: 'TriStateType.True',
                    mandatory: 'true',
                    validationRules: [
                        {
                            rule: 'val == TriStateType.True',
                            message: 'AustrianLaw must be true',
                        },
                    ],
                },
                {
                    name: 'SalesChannel',
                    type: 'string',
                    defaultFunction: 'SalesChannelType.TiedAgent',
                    mandatory: 'true',
                    vpms: {
                        attribute: 'A_Vertriebsweg',
                    },
                },
                {
                    name: 'PaymentWay',
                    type: 'PaymentWay',
                    defaultFunction: 'PaymentWay.Bankinkasso',
                    mandatory: 'true',
                    vpms: {
                        attribute: 'A_Inkassoart',
                        mapping: 'PCTools.PaymentWay2Vpms(val)',
                    },
                },
                {
                    name: 'PaymentInterval',
                    type: 'PaymentInterval',
                    defaultFunction: 'PaymentInterval.Yearly',
                    mandatory: 'true',
                    vpms: {
                        attribute: 'A_Zahlweise',
                        mapping: 'PCTools.PaymentInterval2Vpms(val)',
                    },
                    validationRules: [
                        {
                            rule: '!(offer.PaymentWay==PaymentWay.Zentralinkasso && offer.PaymentInterval==PaymentInterval.Monthly)',
                            message: 'Monthly Zentralinkasso payment is not allowed!',
                        },
                    ],
                },
            ],
            insuredObjects: [
                {
                    insuredObjectType: 'Person',
                    minOccurance: 1,
                    maxOccurance: 1,
                    attributes: [
                        {
                            name: 'FirstName',
                            type: 'string',
                            default: 'Maxi',
                            mandatory: 'true',
                            validationRules: [],
                        },
                        {
                            name: 'LastName',
                            type: 'string',
                            default: 'Test',
                            mandatory: 'true',
                            validationRules: [],
                        },
                    ],
                    insuranceSegments: [
                        {
                            segmentKey: '08.0_RS',
                            mandatory: 'true',
                            questionnaire: {
                                genericQuestions: [
                                    {
                                        questionId: 'versicherungsumfang',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: '1',
                                                availableValues: [
                                                    {
                                                        value: '1',
                                                        description: 'Small',
                                                    },
                                                    {
                                                        value: '2',
                                                        description: 'Medium',
                                                    },
                                                    {
                                                        value: '3',
                                                        description: 'Large',
                                                    },
                                                ],
                                                vpms: {
                                                    attribute: 'A_Versicherungsumfang',
                                                },
                                                validationRules: [],
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'vsu',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: '140000',
                                                availableValues: [
                                                    {
                                                        value: '140000',
                                                        description: '140.000,00',
                                                    },
                                                    {
                                                        value: '165000',
                                                        description: '165.000,00',
                                                    },
                                                    {
                                                        value: '190000',
                                                        description: '190.000,00',
                                                    },
                                                    {
                                                        value: '215000',
                                                        description: '215.000,00',
                                                    },
                                                ],
                                                vpms: {
                                                    attribute: 'A_VSU',
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'versichertePersonen',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: 'VN',
                                                availableValues: [
                                                    {
                                                        value: 'VN und Familie',
                                                        description: 'VN und Familie',
                                                    },
                                                    {
                                                        value: 'Single',
                                                        description: 'Single',
                                                    },
                                                    {
                                                        value: 'Pensionist',
                                                        description: 'Pensionist',
                                                    },
                                                    {
                                                        value: 'VN',
                                                        description: 'VN',
                                                    },
                                                ],
                                                vpms: {
                                                    attribute: 'A_VersichertePersonen',
                                                },
                                                validationRules: [
                                                    {
                                                        rule: "!(versicherungsumfang == '1' && val != 'VN')",
                                                        message: "Wenn Small dann versichertePersonen == 'VN'",
                                                    },
                                                    {
                                                        rule: "!(versicherungsumfang == '2' && val != 'VN und Familie')",
                                                        message: "Wenn Medium dann versichertePersonen == 'VN und Familie'",
                                                    },
                                                    {
                                                        rule: "!(versicherungsumfang == '3' && val == 'VN')",
                                                        message: "Wenn Large dann versichertePersonen in ('Single','Pensionist','VN und Familie')",
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'selbstbehalt',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: '0',
                                                availableValues: [
                                                    {
                                                        value: '0',
                                                        description: 'kein Selbstbehalt',
                                                    },
                                                    {
                                                        value: '1',
                                                        description: 'Anwaltwahl mit Selbstbehalt',
                                                    },
                                                ],
                                                vpms: {
                                                    attribute: 'A_Selbstbehalt',
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'praemienschutz',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: '0',
                                                availableValues: [
                                                    {
                                                        value: '0',
                                                        description: 'Nein',
                                                    },
                                                    {
                                                        value: '1',
                                                        description: 'Ja',
                                                    },
                                                ],
                                                vpms: {
                                                    attribute: 'A_Praemienschutz',
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'zcGutschein',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'string',
                                                default: '-',
                                                vpms: {
                                                    attribute: 'A_ZC_Gutschein',
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'kennzeichenArt',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'AnswerId',
                                                type: 'enumeration',
                                                default: '-',
                                                availableValues: [
                                                    {
                                                        value: '-',
                                                        description: '-',
                                                    },
                                                    {
                                                        value: 'Einzelkennzeichen',
                                                        description: 'Einzelkennzeichen',
                                                    },
                                                    {
                                                        value: 'Wechselkennzeichen',
                                                        description: 'Wechselkennzeichen',
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        questionId: 'kennzeichen',
                                        mandatory: 'true',
                                        attributes: [
                                            {
                                                name: 'Answer',
                                                type: 'string',
                                                default: '',
                                            },
                                        ],
                                    },
                                ],
                            },
                            attributes: [
                                {
                                    name: 'StartDate',
                                    type: 'datetime',
                                    defaultFunction: 'DateTime.Today',
                                    mandatory: 'true',
                                    vpms: {
                                        attribute: 'A_Beginn',
                                        mapping: 'PCTools.DateTime2VpmsFormat(val)',
                                    },
                                    validationRules: [],
                                },
                            ],
                            covers: [
                                {
                                    name: 'RS_LargeBasisdeckung',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            validationRules: [
                                                {
                                                    rule: "(val == TriStateType.True && versicherungsumfang == '3') || (val == TriStateType.False && versicherungsumfang != '3')",
                                                    message: 'RS_LargeBasisdeckung must come in combination with versicherungsumfang Large',
                                                },
                                            ],
                                        },
                                        {
                                            name: 'Value',
                                            mandatory: 'true',
                                            type: 'enumeration',
                                            default: '0',
                                            availableValues: [
                                                {
                                                    value: '0',
                                                    description: 'Nicht gewählt',
                                                },
                                                {
                                                    value: '1',
                                                    description: 'Kompakt ohne KFZ (T)',
                                                },
                                                {
                                                    value: '2',
                                                    description: 'Kompakt mit einem KFZ (TVE)',
                                                },
                                                {
                                                    value: '3',
                                                    description: 'Kompakt mit allen KFZ (TVM)',
                                                },
                                            ],
                                            vpms: {
                                                attribute: 'A_LargeVersicherungsvariante',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "!(obj.Selected == TriStateType.True && val == '0')",
                                                    message: 'If RS_LargeBasisdeckung selected then value must not be 0!',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_SchadenersatzUndStrafRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_SchadenersatzUndStrafRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang.IsIn('2','3')",
                                                    message: 'A_SchadenersatzUndStrafRS ist im Small Paket nicht erlaubt',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_FahrzeugRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.True',
                                            vpms: {
                                                attribute: 'A_FahrzeugRS',
                                                mapping: "val == TriStateType.False ? 'Nein' : obj.Value",
                                            },
                                        },
                                        {
                                            name: 'Value',
                                            mandatory: 'true',
                                            type: 'enumeration',
                                            default: 'Personenkraftwagen',
                                            availableValues: [
                                                { value: 'Nein' },
                                                { value: 'Sonstige Anhänger' },
                                                { value: 'Wohnwagenanhänger' },
                                                { value: 'Kombi' },
                                                { value: 'Motorrad' },
                                                { value: 'Lastkraftwagen bis 1,5t' },
                                                { value: 'Lastkraftwagen über 1,5t' },
                                                { value: 'Mähdrescher EIG' },
                                                { value: 'Mähdrescher LDW' },
                                                { value: 'Motorkarren' },
                                                { value: 'Moped 1 sitzig' },
                                                { value: 'Moped 2 sitzig' },
                                                { value: 'Personenkraftwagen' },
                                                { value: 'Sattel Kraftfahrzeug' },
                                                { value: 'Wohnmobil über 3,5 t (1,5 t)' },
                                                { value: 'Wohnmobil bis 3,5 t (1,5 t)' },
                                                { value: 'Zugmaschine <= 25kmh EIG' },
                                                { value: 'Zugmaschine <= 25kmh LDW' },
                                                { value: 'Zugmaschine > 25 kmh EIG' },
                                                { value: 'Zugmaschine > 25 kmh LDW' },
                                                { value: 'alle KFZ' },
                                            ],
                                            validationRules: [
                                                {
                                                    rule: "!(obj.Selected == TriStateType.True && val == 'Nein')",
                                                    message: "If RS_FahrzeugRS selected then value must not be 'Nein'!",
                                                },
                                                {
                                                    rule: "!(versicherungsumfang == '1' && val == 'Nein')",
                                                    message: 'Im Small package muss der Fahrzeug-RS includiert werden!',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_FahrzeugVertragsRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_FahrzeugVertragsRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "!(PCTools.CoverValue(offer,'08.0_RS','RS_FahrzeugRS') == 'Nein' && val == TriStateType.True)",
                                                    message: 'RS_FahrzeugVertragsRS only allowed if RS_FahrzeugRS selected!',
                                                },
                                                {
                                                    rule: "!(versicherungsumfang.IsIn('1','2') && RS_FahrzeugRS_value == 'alle KFZ' && RS_FahrzeugVertragsRS == 'false')",
                                                    message: 'Wenn man alle KFZ versichert dann muss FahrzeugVertragRS includiert werden!',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_BeratungsRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.True',
                                            vpms: {
                                                attribute: 'A_BeratungsRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_LenkerRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_LenkerRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "!(versicherungsumfang== '3' && RS_FahrzeugRS_selected == 'true' && RS_LenkerRS == 'false')",
                                                    message: 'Im Large Paket kommt LenkerRS zusammen mit FahrzeugRS',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_EigentumMiete',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_EigentumMiete',
                                                mapping: 'val == TriStateType.True ? obj.Value : PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang== '3'",
                                                    message: 'RS_EigentumMiete comes only in combination with package Large',
                                                },
                                            ],
                                        },
                                        {
                                            name: 'Value',
                                            mandatory: 'true',
                                            type: 'enumeration',
                                            default: '0',
                                            availableValues: [
                                                {
                                                    value: '0',
                                                    description: 'Nein',
                                                },
                                                {
                                                    value: '1',
                                                    description: 'Hauptwohnsitz',
                                                },
                                                {
                                                    value: '2',
                                                    description: 'alle Einheiten innerh. Österreichs',
                                                },
                                            ],
                                        },
                                    ],
                                    risks: [],
                                },
                                {
                                    name: 'RS_Vermieterrisiko',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_Vermieterrisiko',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang== '3'",
                                                    message: 'RS_Vermieterrisiko comes only in combination with package Large',
                                                },
                                                {
                                                    rule: "!(RS_Vermieterrisiko == 'true' && RS_EigentumMiete_selected == 'false')",
                                                    message: 'RS_Vermieterrisiko darf nur zusammen mit RS_EigentumMiete gewählt werden!',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_ErbUndFamilienRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_ErbUndFamilienRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang == '3'",
                                                    message: 'RS_ErbUndFamilienRS darf nur im Large Paket gewählt werden',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_PflegebeduerftigePersonen',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_PflegebeduerftigePersonen',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang== '3'",
                                                    message: 'RS_PflegebeduerftigePersonen darf nur im Large Paket gewählt werden',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_PlusPaket',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_PlusPaket',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang == '3'",
                                                    message: 'RS_PlusPaket darf nur im Large Paket gewählt werden',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_ErmittlungsstrafRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_ErmittlungsstrafRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_Vorsatzdelikte',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_Vorsatzdelikte',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang == '3'",
                                                    message: 'RS_Vorsatzdelikte darf nur im Large Paket gewählt werden',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_Europadeckung',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_Europadeckung',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                            validationRules: [
                                                {
                                                    rule: "val == TriStateType.False || versicherungsumfang == '3'",
                                                    message: 'RS_Europadeckung darf nur im Large Paket gewählt werden',
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'RS_SpezialStrafRS',
                                    attributes: [
                                        {
                                            name: 'Selected',
                                            mandatory: 'true',
                                            type: 'string',
                                            defaultFunction: 'TriStateType.False',
                                            vpms: {
                                                attribute: 'A_SpezialStrafRS',
                                                mapping: 'PCTools.Bool10(val)',
                                            },
                                        },
                                    ],
                                },
                            ],
                            discounts: [
                                {
                                    type: 'distributionChannelDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'true',
                                        },
                                    ],
                                },
                                {
                                    type: 'onlineDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'campaingDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'conversionDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'employeeDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'SpecialLoading',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'CouponDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                        },
                                    ],
                                },
                                {
                                    type: 'specialDiscount',
                                    attributes: [
                                        {
                                            name: 'DiscountSelected',
                                            mandatory: 'true',
                                            type: 'bool',
                                            defaultFunction: 'false',
                                            vpms: {
                                                attribute: 'A_Sondernachlass',
                                                mapping: '(obj.DiscountSelected??false) ? (obj.Value??0) : 0',
                                            },
                                        },
                                        {
                                            name: 'Value',
                                            mandatory: 'false',
                                            type: 'decimal',
                                            defaultFunction: '0M',
                                            validationRules: [
                                                {
                                                    rule: 'val>= 0 || obj.DiscountSelected == false',
                                                    message: 'the specialDiscount value must be >= 0',
                                                },
                                                {
                                                    rule: 'val <= 100 || obj.DiscountSelected == false',
                                                    message: 'the specialDiscount value must be <= 100',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
            allVPMSAttributes: [
                {
                    attribute: 'A_Tarifierungsdatum',
                    defaultFunction: 'PCTools.DateTime2VpmsFormat(DateTime.Now)',
                },
                {
                    attribute: 'A_Diplomatengruppe',
                    defaultFunction: 'PCTools.PolicyHolderDiplomatType(offer)',
                },
                {
                    attribute: 'A_VST_PSatz',
                    default: '12',
                },
                {
                    attribute: 'A_PLZ',
                    defaultFunction: "PCTools.PolicyHolderPostalCode(offer,'1000')",
                },
                {
                    attribute: 'A_NZ_Manuell',
                    default: '0',
                },
            ],
            allVPMSProperties: [
                {
                    property: 'xP_Zeitstempel',
                },
                {
                    property: 'xP_Version',
                },
                {
                    property: 'xP_JahresPraemie_NTOvorUJZ',
                },
                {
                    property: 'xP_JahresPraemie_UJZ',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'AnnualPaymentSurcharge',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'AnnualPaymentSurcharge',
                        },
                    ],
                },
                {
                    property: 'xP_JahresPraemie_NTO',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'AnnualNetPremium',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'AnnualNetPremium',
                        },
                    ],
                },
                {
                    property: 'xP_JahresPraemie_VST',
                },
                {
                    property: 'xP_JahresPraemie_BTO',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'AnnualGrossPremium',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'AnnualGrossPremium',
                        },
                    ],
                },
                {
                    property: 'xP_ErstPraemie_NTOvorUJZ',
                },
                {
                    property: 'xP_ErstPraemie_UJZ',
                },
                {
                    property: 'xP_ErstPraemie_NTO',
                },
                {
                    property: 'xP_ErstPraemie_VST',
                },
                {
                    property: 'xP_ErstPraemie_BTO',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'InitialPremium',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'InitialPremium',
                        },
                    ],
                },
                {
                    property: 'xP_RatePraemie_NTOvorUJZ',
                },
                {
                    property: 'xP_RatePraemie_UJZ',
                },
                {
                    property: 'xP_RatePraemie_NTO',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'RegularNetPremium',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'RegularNetPremium',
                        },
                    ],
                },
                {
                    property: 'xP_RatePraemie_VST',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'InsuranceTax',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'InsuranceTax',
                        },
                    ],
                },
                {
                    property: 'xP_RatePraemie_BTO',
                    reverseMappings: [
                        {
                            level: 'policy',
                            field: 'RegularPremium',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                            field: 'RegularPremium',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Dauerrabatt_PSatz',
                },
                {
                    property: 'xP_NZ_Vertriebswegsrabatt_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'DistributionChannelDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Onlinenachlass_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'OnlineDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Aktionsnachlass_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'CampaingDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Konvertierungsnachlass_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'ConversionDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Sondernachlass_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'SpecialDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_IMAS_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'EmployeeDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_ZCNachlass_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'CouponDiscount',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_Zuschlag_PSatz',
                    reverseMappings: [
                        {
                            level: 'policy',
                        },
                        {
                            level: 'insuranceSegment',
                            segmentKey: '08.0_RS',
                        },
                        {
                            level: 'segmentDiscount',
                            segmentKey: '08.0_RS',
                            discountType: 'SpecialLoading',
                        },
                    ],
                },
                {
                    property: 'xP_NZ_UJZ_PSatz',
                },
            ],
            productAttributes: [
                {
                    name: 'RelatedCustomerSegment',
                    type: 'CustomerSegment',
                    default: 'Private',
                    mandatory: 'true',
                    validationRules: [
                        {
                            rule: 'val == CustomerSegment.Private',
                            message: 'CustomerSegment must be Private',
                        },
                    ],
                },
            ],
            questionnaire: {
                genericQuestions: [
                    {
                        questionId: 'EMPLOYEE_DISCOUNT',
                        attributes: [
                            {
                                name: 'AnswerId',
                                type: 'enumeration',
                                default: 'NotEmployee',
                                availableValues: [
                                    {
                                        value: 'NotEmployee',
                                        description: 'Kein Mitarbeiter',
                                    },
                                    {
                                        value: 'G1',
                                        description: 'G1',
                                    },
                                    {
                                        value: 'G2',
                                        description: 'G2',
                                    },
                                    {
                                        value: 'G3',
                                        description: 'G3',
                                    },
                                ],
                                vpms: {
                                    attribute: 'A_Mitarbeitergruppe',
                                },
                            },
                        ],
                    },
                ],
            },
            templates: [
                {
                    templateName: 'minimalOffer',
                    packageDescriptionLabel: 'Minimum RS',
                    packageDescriptionTooltip: 'Das Offert mit dem kleinstmöglichsten Deckungsumfang',
                    coverageHeadingLabel: 'Deckungsumfang',
                    coverageHeadingTooltip: 'Weitere Deckungsoptionen sind möglich',
                },
                {
                    templateName: 'Small',
                    enabled: true,
                    packageDescriptionLabel: 'Small RS',
                    packageDescriptionTooltip: 'TBD',
                    coverageHeadingLabel: 'Deckungsumfang',
                    coverageHeadingTooltip: 'Weitere Deckungsoptionen sind möglich',
                    rules: [
                        {
                            variable: 'versicherungsumfang',
                            default: '1',
                        },
                        {
                            variable: 'vsu',
                            mapping: {
                                sourceVariable: 'wub_sumInsured',
                                valueMappings: [
                                    {
                                        value: '140.000 €',
                                        mappedTo: '140000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 140.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '165.000 €',
                                        mappedTo: '165000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 165.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '190.000 €',
                                        mappedTo: '190000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 190.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '215.000 €',
                                        mappedTo: '215000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 215.000 €',
                                                status: 'included',
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                        {
                            variable: 'selbstbehalt',
                            defaultFunction: "wub_deductible == 'keine Selbstbeteiligung' ? '0' : '1'",
                            coverages: [
                                {
                                    label: 'Anwaltwahl mit Selbstbehalt',
                                    statusFunction: "value == '1' ? 'included' : 'optional'",
                                },
                            ],
                        },
                        {
                            variable: 'praemienschutz',
                            default: '0',
                            coverages: [
                                {
                                    label: 'Versicherungsschutz selbst bei Arbeitslosigkeit und keiner Prämienverrechnung',
                                    status: 'optional',
                                },
                            ],
                        },
                        {
                            variable: 'RS_FahrzeugRS_selected',
                            defaultFunction: 'TriStateType.True',
                        },
                        {
                            variable: 'RS_FahrzeugRS_value',
                            defaultFunction: "'Personenkraftwagen'",
                            coverages: [
                                {
                                    label: 'Fahrzeug RS für ein Personenkraftwagen',
                                    statusFunction: "'included'",
                                },
                                {
                                    label: 'Fahrzeug RS für alle Personenkraftwagen',
                                    status: 'optional',
                                },
                            ],
                        },
                        {
                            variable: 'RS_FahrzeugVertragsRS',
                            defaultFunction: 'TriStateType.False',
                            coverages: [
                                {
                                    label: 'Fahrzeug-Vertrags RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_LenkerRS',
                            defaultFunction: "wub_foreignVehicles == '1' ? TriStateType.True : TriStateType.False",
                            coverages: [
                                {
                                    label: 'Lenker RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_BeratungsRS',
                            defaultFunction: "wub_importantRisks == 'Anspruch auf Rechtsberatung' ? TriStateType.True : TriStateType.False",
                            coverages: [
                                {
                                    label: 'Fahrzeug-Vertrags RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_ErmittlungsstrafRS',
                            defaultFunction: "wub_criminalLawProtection == '1' ? TriStateType.True : TriStateType.False",
                            coverages: [
                                {
                                    label: 'Ermittlungsstraf-RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_SpezialStrafRS',
                            defaultFunction: 'TriStateType.False',
                            coverages: [
                                {
                                    label: 'SpezialStrafRS-RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                    ],
                },
                {
                    templateName: 'Medium',
                    enabled: true,
                    packageDescriptionLabel: 'Medium RS',
                    packageDescriptionTooltip: 'TBD',
                    coverageHeadingLabel: 'Deckungsumfang',
                    coverageHeadingTooltip: 'Weitere Deckungsoptionen sind möglich',
                    rules: [
                        {
                            variable: 'versicherungsumfang',
                            default: '2',
                        },
                        {
                            variable: 'vsu',
                            mapping: {
                                sourceVariable: 'wub_sumInsured',
                                valueMappings: [
                                    {
                                        value: '140.000 €',
                                        mappedTo: '140000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 140.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '165.000 €',
                                        mappedTo: '165000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 165.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '190.000 €',
                                        mappedTo: '190000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 190.000 €',
                                                status: 'included',
                                            },
                                            {
                                                label: 'Versicherungssumme bis zu 215.000 €',
                                                status: 'optional',
                                            },
                                        ],
                                    },
                                    {
                                        value: '215.000 €',
                                        mappedTo: '215000',
                                        coverages: [
                                            {
                                                label: 'Versicherungssumme 215.000 €',
                                                status: 'included',
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                        {
                            variable: 'selbstbehalt',
                            defaultFunction: "wub_deductible == 'keine Selbstbeteiligung' ? '0' : '1'",
                            coverages: [
                                {
                                    label: 'Anwaltwahl mit Selbstbehalt',
                                    statusFunction: "value == '1' ? 'included' : 'optional'",
                                },
                            ],
                        },
                        {
                            variable: 'versichertePersonen',
                            defaultFunction: "'VN und Familie'",
                            coverages: [
                                {
                                    label: 'Versicherungsschutz für die ganze Familie',
                                    statusFunction: "'included'",
                                },
                            ],
                        },
                        {
                            variable: 'praemienschutz',
                            default: '0',
                            coverages: [
                                {
                                    label: 'Versicherungsschutz selbst bei Arbeitslosigkeit und keiner Prämienverrechnung',
                                    status: 'optional',
                                },
                            ],
                        },
                        {
                            variable: 'RS_FahrzeugRS_selected',
                            defaultFunction: "wub_hasCar == '1' ? TriStateType.True : TriStateType.False",
                        },
                        {
                            variable: 'RS_FahrzeugRS_value',
                            defaultFunction: "wub_hasCar == '1' ? 'Personenkraftwagen' : 'Nein'",
                            coverages: [
                                {
                                    label: 'Fahrzeug RS für ein Personenkraftwagen',
                                    statusFunction: "value == 'Nein' ? 'optional' : 'included'",
                                },
                                {
                                    label: 'Fahrzeug RS für alle Personenkraftwagen',
                                    status: 'optional',
                                },
                            ],
                        },
                        {
                            variable: 'RS_FahrzeugVertragsRS',
                            defaultFunction: 'TriStateType.False',
                            coverages: [
                                {
                                    label: 'Fahrzeug-Vertrags RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_BeratungsRS',
                            defaultFunction: "wub_importantRisks == 'Anspruch auf Rechtsberatung' ? TriStateType.True : TriStateType.False",
                            coverages: [
                                {
                                    label: 'Fahrzeug-Vertrags RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                        {
                            variable: 'RS_LenkerRS',
                            defaultFunction: "wub_foreignVehicles == '1' ? TriStateType.True : TriStateType.False",
                            coverages: [
                                {
                                    label: 'Lenker RS',
                                    statusFunction: "value == 'False' ? 'optional' : 'included'",
                                },
                            ],
                        },
                    ],
                },
            ],
            wuB: [
                {
                    key: 'policyHoldersOption',
                    rules: [
                        {
                            rule: "!(versichertePersonen.IsIn('VN','Single') && wub_policyHoldersOption != 'Nur Versicherungsnehmer')",
                            message: 'WuB Versicherungsnehmer',
                        },
                        {
                            rule: "!(versichertePersonen.IsNotIn('VN','Single') && wub_policyHoldersOption == 'Nur Versicherungsnehmer')",
                            message: 'WuB Versicherungsnehmer',
                        },
                    ],
                },
                {
                    key: 'hasCar',
                    rules: [
                        {
                            rule: "(RS_FahrzeugRS_selected == 'true' ? '1' : '0') == wub_hasCar",
                            message: 'WuB fremde Fahrzeuge',
                        },
                    ],
                },
                {
                    key: 'foreignVehicles',
                    rules: [
                        {
                            rule: "(RS_LenkerRS =='true' ? '1' : '0') == wub_foreignVehicles",
                            message: 'WuB fremde Fahrzeuge',
                        },
                    ],
                },
                {
                    key: 'importantRisks',
                    rules: [
                        {
                            rule: '1 == 1',
                            message: 'WuB importantRisks',
                        },
                    ],
                },
                {
                    key: 'criminalLawProtection',
                    rules: [
                        {
                            rule: "(RS_ErmittlungsstrafRS == 'true' ? '1' : '0') == wub_criminalLawProtection",
                            message: 'WuB Ermittlungsstraf-RS',
                        },
                    ],
                },
                {
                    key: 'intentionalOffenseCovver',
                    rules: [
                        {
                            rule: "(RS_Vorsatzdelikte == 'true' ? '1' : '0') == wub_intentionalOffenseCovver",
                            message: 'WuB Vorsatzdelikte',
                        },
                    ],
                },
                {
                    key: 'tenantOrPropertyOwner',
                    rules: [
                        {
                            rule: "!(wub_tenantOrPropertyOwner == '0' && RS_EigentumMiete <> '0')",
                            message: 'WuB Immobilien',
                        },
                        {
                            rule: "!(wub_tenantOrPropertyOwner == 'Ja, 1 Immobilie' && RS_EigentumMiete <> '1')",
                            message: 'WuB Immobilien',
                        },
                        {
                            rule: "!(wub_tenantOrPropertyOwner == 'Ja, mehrere Immobilien' && RS_EigentumMiete <> '2')",
                            message: 'WuB Immobilien',
                        },
                    ],
                },
                {
                    key: 'inheritanceFamilyLaw',
                    rules: [
                        {
                            rule: "(RS_ErbUndFamilienRS == 'true' ? '1' :'0') == wub_inheritanceFamilyLaw",
                            message: 'WuB Familienrecht',
                        },
                    ],
                },
                {
                    key: 'euWideProtection',
                    rules: [
                        {
                            rule: "(RS_Europadeckung == 'true' ? '1' :'0') == wub_euWideProtection",
                            message: 'WuB EU-Ausland',
                        },
                    ],
                },
                {
                    key: 'sumInsured',
                    rules: [
                        {
                            rule: "wub_sumInsured.Replace(' €','').Replace('.','') == vsu",
                            message: 'WuB Versicherungssumme',
                        },
                    ],
                },
                {
                    key: 'deductible',
                    rules: [
                        {
                            rule: "(wub_deductible == 'Selbstbeteiligung' ? '1' : '0') == selbstbehalt",
                            message: 'Wub Selbstbehalt',
                        },
                    ],
                },
            ],
            variables: [
                {
                    name: 'versicherungsumfang',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].questionnaire.genericQuestions[?(@.questionId=='versicherungsumfang')].answerId",
                },
                {
                    name: 'vsu',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].questionnaire.genericQuestions[?(@.questionId=='vsu')].answerId",
                },
                {
                    name: 'versichertePersonen',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].questionnaire.genericQuestions[?(@.questionId=='versichertePersonen')].answerId",
                },
                {
                    name: 'selbstbehalt',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].questionnaire.genericQuestions[?(@.questionId=='selbstbehalt')].answerId",
                },
                {
                    name: 'praemienschutz',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].questionnaire.genericQuestions[?(@.questionId=='praemienschutz')].answerId",
                },
                {
                    name: 'RS_FahrzeugRS_selected',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_FahrzeugRS')].selected",
                },
                {
                    name: 'RS_FahrzeugRS_value',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_FahrzeugRS')].value",
                },
                {
                    name: 'RS_EigentumMiete_selected',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_EigentumMiete')].selected",
                },
                {
                    name: 'RS_EigentumMiete_value',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_EigentumMiete')].value",
                },
                {
                    name: 'RS_Vermieterrisiko',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_Vermieterrisiko')].selected",
                },
                {
                    name: 'RS_FahrzeugVertragsRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_FahrzeugVertragsRS')].selected",
                },
                {
                    name: 'RS_BeratungsRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_BeratungsRS')].selected",
                },
                {
                    name: 'RS_ErbUndFamilienRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_ErbUndFamilienRS')].selected",
                },
                {
                    name: 'RS_ErmittlungsstrafRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_ErmittlungsstrafRS')].selected",
                },
                {
                    name: 'RS_Vorsatzdelikte',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_Vorsatzdelikte')].selected",
                },
                {
                    name: 'RS_LenkerRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_LenkerRS')].selected",
                },
                {
                    name: 'RS_SchadenersatzUndStrafRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_SchadenersatzUndStrafRS')].selected",
                },
                {
                    name: 'RS_Europadeckung',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_SchadenersatzUndStrafRS')].selected",
                },
                {
                    name: 'RS_SpezialStrafRS',
                    jPath: "$.insuredObjects[0].insuranceSegments[0].selectableUnits[?(@.name == 'RS_SpezialStrafRS')].selected",
                },
                {
                    name: 'wub_policyHoldersOption',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'RS_Europadeckung')].selected",
                },
                {
                    name: 'wub_hasCar',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'hasCar')].value",
                },
                {
                    name: 'wub_foreignVehicles',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'foreignVehicles')].value",
                },
                {
                    name: 'wub_importantRisks',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'importantRisks')].value",
                },
                {
                    name: 'wub_criminalLawProtection',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'criminalLawProtection')].value",
                },
                {
                    name: 'wub_intentionalOffenseCovver',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'intentionalOffenseCovver')].value",
                },
                {
                    name: 'wub_tenantOrPropertyOwner',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'tenantOrPropertyOwner')].value",
                },
                {
                    name: 'wub_inheritanceFamilyLaw',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'inheritanceFamilyLaw')].value",
                },
                {
                    name: 'wub_euWideProtection',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'euWideProtection')].value",
                },
                {
                    name: 'wub_sumInsured',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'sumInsured')].value",
                },
                {
                    name: 'wub_deductible',
                    jPath: "$.products[0].productCategory.advisoryDocumentation.recommendationData[?(@.key == 'deductible')].value",
                },
            ],
        },
    ],
};
